import React from 'react';
import { WithRole } from '../common';
import { ScheduleList } from './List/ScheduleList';
import { ScheduleAvailableRoles } from 'src/constants/roles';
import NoAccess from '../common/Errors/NoAccess';

export default {
    list: (
        <WithRole roles={ScheduleAvailableRoles} orElse={<NoAccess />}>
            <ScheduleList />
        </WithRole>
    )
};
